var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 5.0625H37.125C37.5726 5.0625 38.0018 5.24029 38.3182 5.55676C38.6347 5.87322 38.8125 6.30245 38.8125 6.75V47.25C38.8125 47.6976 38.6347 48.1268 38.3182 48.4432C38.0018 48.7597 37.5726 48.9375 37.125 48.9375H16.875C16.4274 48.9375 15.9982 48.7597 15.6818 48.4432C15.3653 48.1268 15.1875 47.6976 15.1875 47.25V6.75C15.1875 6.30245 15.3653 5.87322 15.6818 5.55676C15.9982 5.24029 16.4274 5.0625 16.875 5.0625ZM10.125 6.75C10.125 4.95979 10.8362 3.2429 12.102 1.97703C13.3679 0.711159 15.0848 0 16.875 0L37.125 0C38.9152 0 40.6321 0.711159 41.898 1.97703C43.1638 3.2429 43.875 4.95979 43.875 6.75V47.25C43.875 49.0402 43.1638 50.7571 41.898 52.023C40.6321 53.2888 38.9152 54 37.125 54H16.875C15.0848 54 13.3679 53.2888 12.102 52.023C10.8362 50.7571 10.125 49.0402 10.125 47.25V6.75ZM27 43.875C27.8951 43.875 28.7535 43.5194 29.3865 42.8865C30.0194 42.2535 30.375 41.3951 30.375 40.5C30.375 39.6049 30.0194 38.7465 29.3865 38.1135C28.7535 37.4806 27.8951 37.125 27 37.125C26.1049 37.125 25.2465 37.4806 24.6135 38.1135C23.9806 38.7465 23.625 39.6049 23.625 40.5C23.625 41.3951 23.9806 42.2535 24.6135 42.8865C25.2465 43.5194 26.1049 43.875 27 43.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobg1);
export default __webpack_public_path__ + "static/media/mobg1.07f6fbbdbdda3cf2edea75e8d467d1f2.svg";
export { ForwardRef as ReactComponent };